(function () {
  'use strict';

  var MOBILE_MAX = 1023;
  var bar = document.querySelector('[data-sb-sticky-atc-mobile]');
  if (!bar) return;

  var mainForm = document.getElementById('add-to-cart-form-desktop');
  if (!mainForm) return;

  var stickyBtn = bar.querySelector('[data-sticky-atc]');
  if (!stickyBtn) return;

  var observer = null;
  var observedTarget = null;
  var resizeTimer = null;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function isShown(el) {
    if (!el) return false;
    return window.getComputedStyle(el).display !== 'none';
  }

  function getMainAtcButton() {
    return mainForm.querySelector('.sb-add-to-cart');
  }

  function getMainProceedButton() {
    return mainForm.querySelector('.sb-proceed-checkout');
  }

  function getMainNotifyButton() {
    return mainForm.querySelector('[data-notify-button]');
  }

  function getWatchTarget() {
    var proceed = getMainProceedButton();
    var atc = getMainAtcButton();
    var notify = getMainNotifyButton();

    if (isShown(proceed)) return proceed;
    if (isShown(atc)) return atc;
    if (isShown(notify)) return notify;
    return atc || proceed || notify || mainForm.querySelector('.custom-dropdown-container');
  }

  function getActiveMainButton() {
    var proceed = getMainProceedButton();
    var atc = getMainAtcButton();
    var notify = getMainNotifyButton();

    if (isShown(proceed)) return proceed;
    if (isShown(atc)) return atc;
    if (isShown(notify)) return notify;
    return null;
  }

  function syncFromMain() {
    var mainBtn = getActiveMainButton();
    if (!mainBtn || !isShown(mainBtn)) {
      stickyBtn.classList.add('is-hidden');
      return;
    }

    stickyBtn.classList.remove('is-hidden');
    stickyBtn.textContent = mainBtn.textContent.trim();
    stickyBtn.classList.toggle(
      'sb-sticky-atc-mobile__btn--proceed',
      mainBtn.classList.contains('sb-proceed-checkout')
    );
  }

  function updateBarHeight() {
    if (!isMobile()) {
      document.documentElement.style.removeProperty('--sb-sticky-atc-mobile-height');
      return;
    }
    document.documentElement.style.setProperty('--sb-sticky-atc-mobile-height', bar.offsetHeight + 'px');
  }

  function setVisible(visible) {
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    document.body.classList.toggle('sb-sticky-atc-mobile-visible', visible);
    if (visible) syncFromMain();
    updateBarHeight();
  }

  function initObserver() {
    if (!('IntersectionObserver' in window)) return;

    var watchTarget = getWatchTarget();
    if (!watchTarget) return;

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          if (!isMobile()) {
            setVisible(false);
            return;
          }
          var targetVisible = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          setVisible(!targetVisible);
        },
        { threshold: 0, rootMargin: '0px' }
      );
    }

    if (observedTarget && observedTarget !== watchTarget) {
      observer.unobserve(observedTarget);
      observedTarget = null;
    }
    if (watchTarget && watchTarget !== observedTarget) {
      observer.observe(watchTarget);
      observedTarget = watchTarget;
    }
  }

  stickyBtn.addEventListener('click', function (e) {
    if (!isMobile()) return;
    e.preventDefault();
    var mainBtn = getActiveMainButton();
    if (mainBtn) mainBtn.click();
  });

  var mutationObserver = new MutationObserver(function () {
    initObserver();
    syncFromMain();
    if (bar.classList.contains('is-visible')) updateBarHeight();
  });
  mutationObserver.observe(mainForm, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['style', 'class', 'data-pre-order']
  });

  function boot() {
    if (!isMobile()) {
      setVisible(false);
      if (observedTarget && observer) {
        observer.unobserve(observedTarget);
        observedTarget = null;
      }
      return;
    }
    initObserver();
    syncFromMain();
    updateBarHeight();
  }

  boot();

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(boot, 150);
  });

  window.addEventListener(
    'scroll',
    function () {
      if (bar.classList.contains('is-visible')) syncFromMain();
    },
    { passive: true }
  );
})();
